import { useDroppable } from '@dnd-kit/core'
import React from 'react'
import { DraggableOrderCard } from './DraggableOrderCard'

export function OrderColumn({ columnId, title, count, orders, badgeColor, onUpdateStatus, buttonText, buttonColor, showUndo, undoText, onUndo, isDragging, pendingOrders, pulse, bounce }) {
  const { isOver, setNodeRef } = useDroppable({
    id: columnId,
  })

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">{title}</h2>
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${badgeColor} ${pulse ? 'animate-pulse ring-2 ring-red-400' : ''}`}>
          {count}
        </span>
      </div>

      <div
        ref={setNodeRef}
        className={`space-y-4 min-h-[200px] p-2 -m-2 rounded-lg transition-all duration-200 ${
          isOver
            ? 'bg-blue-100 ring-2 ring-blue-400 scale-[1.02]'
            : isDragging
              ? 'bg-gray-50 ring-1 ring-gray-300 ring-dashed'
              : ''
        }`}
      >
        {orders.length === 0 ? (
          <div className={`bg-white rounded-lg p-6 text-center transition-all duration-200 ${
            isOver
              ? 'border-2 border-dashed border-blue-400 bg-blue-50 text-blue-600 scale-105'
              : isDragging
                ? 'border border-dashed border-gray-300 text-gray-400'
                : 'text-gray-500'
          }`}>
            {isOver ? '↓ Drop here' : 'No orders'}
          </div>
        ) : (
          orders.map(order => (
            <DraggableOrderCard
              key={order.id}
              order={order}
              onUpdateStatus={onUpdateStatus}
              buttonText={buttonText}
              buttonColor={buttonColor}
              showUndo={showUndo}
              undoText={undoText}
              onUndo={onUndo}
              isPending={pendingOrders.has(order.id)}
              bounce={bounce}
            />
          ))
        )}
      </div>
    </div>
  )
}
